import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { RestApiService } from '../rest-api/rest-api.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class UserManagementService {
    private _$user: BehaviorSubject<any> = new BehaviorSubject(null);

    constructor(private _restApi: RestApiService, private http: HttpClient) {}

    public get user$(): Observable<any> {
        return this._$user.asObservable();
    }

    loadUser() {
        const _url = `${environment.APIEndpoint}api/v1/User`;
        this._restApi.requestGET<any>(_url, null, true, true).then(data => {
            this._$user.next(data);
        })
    }
    
    getUser() {
        let _url = `${environment.APIEndpoint}api/v1/User`;
        let p = this._restApi.requestGET<any>(_url, null, true, true);
        return p;
    }

    getBillingContact(id) {
        let _url = `${environment.APIEndpoint}api/v1/user/${id}`;
        let p = this._restApi.requestGET<any>(_url, null, true, true);
        return p;
    }

    getUserMock() {
        let _url = '/assets/mock/user.json';
        let p = this._restApi.requestGET<any>(_url, null, true, true);
        return p;
    }

    updateUser(user) {
        let _url = `${environment.APIEndpoint}api/v1/User/${user.id}/ChangePersonalData`;
        const p = this._restApi.requestRawBodyPOST<any>(_url, JSON.stringify(user), null, true, true);
        return p;
    }

    changePassword(username: string, oldPassword: string, newPassword: string) {
        const _url = `${environment.APIEndpoint}api/v1/User/ChangePassword`;
        const password = {
            password: newPassword,
            oldPassword: oldPassword
        };
        return this._restApi.requestRawBodyPOST<any>(_url, JSON.stringify(password), null, true, true);
    }

    checkUserToken(validationObject) {
        let _url = `${environment.APIEndpoint}api/v1/User/ValidateToken`;
        let result = this._restApi.requestRawBodyPOST<any>(_url, validationObject, true, false);
        return result;
    }

    resetPassword(resetPasswordObject) {
        let _url = `${environment.APIEndpoint}api/v1/User/ChangePasswordWithToken`;
        let result = this._restApi.requestRawBodyPOST<any>(_url, resetPasswordObject, true, false);
        return result;
    }
}
